export enum SalesRepSubjectType {
    UserProfile = 1,
    Job = 2,
    Quote = 3
}

export enum SalesRepAssignmentStatus {
    Pending = 1,
    Approved = 2,
    Rejected = 3,
    Superseded = 4,
    AutoApproved = 5
}

export enum SalesRepApprovalStatusFilter {
    Pending = 'pending',
    Approved = 'approved',
    Rejected = 'rejected',
    All = 'all'
}

export const SalesRepApprovalStatusFilterStatuses: Record<SalesRepApprovalStatusFilter, SalesRepAssignmentStatus[]> = {
    [SalesRepApprovalStatusFilter.Pending]: [SalesRepAssignmentStatus.Pending],
    [SalesRepApprovalStatusFilter.Approved]: [SalesRepAssignmentStatus.Approved, SalesRepAssignmentStatus.AutoApproved],
    [SalesRepApprovalStatusFilter.Rejected]: [SalesRepAssignmentStatus.Rejected],
    [SalesRepApprovalStatusFilter.All]: [],
};

export const SalesRepSubjectTypeDisplay: Record<number, { label: string; cssClass: string }> = {
    [SalesRepSubjectType.UserProfile]: { label: 'Customer', cssClass: 'bg-blue-100 text-blue-800' },
    [SalesRepSubjectType.Job]: { label: 'Job', cssClass: 'bg-violet-100 text-violet-800' },
    [SalesRepSubjectType.Quote]: { label: 'Quote', cssClass: 'bg-amber-100 text-amber-800' },
};

export const SalesRepAssignmentStatusDisplay: Record<number, { label: string; cssClass: string }> = {
    [SalesRepAssignmentStatus.Pending]: { label: 'Pending', cssClass: 'bg-amber-100 text-amber-800' },
    [SalesRepAssignmentStatus.Approved]: { label: 'Approved', cssClass: 'bg-green-100 text-green-800' },
    [SalesRepAssignmentStatus.AutoApproved]: { label: 'Auto-approved', cssClass: 'bg-green-100 text-green-800' },
    [SalesRepAssignmentStatus.Rejected]: { label: 'Rejected', cssClass: 'bg-red-100 text-red-800' },
    [SalesRepAssignmentStatus.Superseded]: { label: 'Superseded', cssClass: 'bg-neutral-100 text-neutral-600' },
};
